import React from "react";
import { useResizeObserver } from "./useResizeObserver";
export function ResizeComponent(WrappedComponent) {
    const ComponentWithInjectedProps = (props) => {
        const [ref, size] = useResizeObserver();
        const { height, width } = props.size;
        return (React.createElement("div", { ref: ref, className: "responsive-wrapper", style: { height: height, width: width !== null && width !== void 0 ? width : "100%" } }, size && React.createElement(WrappedComponent, Object.assign({}, props, { size: size }))));
    };
    return ComponentWithInjectedProps;
}
//# sourceMappingURL=ResizeComponent.js.map